import styled from 'styled-components';

export const WrapperSearchInput = styled.div`
  .CellInput {
    width: 100%;
    padding-right: 15px;
    .InputWrapper {
      input:not([type='radio']):not([type='checkbox']):not([type='file']),
      textarea,
      canvas {
        height: 30px;
        border-color: ${props => props.borderInputColor};
      }
    }
  }
  .Button_Small {
    padding: 0 25px !important;
    line-height: 30px;
    white-space: nowrap;
  }
`;

export const WrapperSearchList = styled.div`
  padding-top: 20px;
  max-height: 500px;
  overflow: auto;
  .Subtitle {
    font-size: 0.8em;
    margin-bottom: 15px;
    color: ${props => props.textColor};
  }
`;

export const WrapperContent = styled.div`
  margin-bottom: 20px;
  p {
    margin-bottom: 5px;
    font-size: 0.9em;
    b {
      font-weight: bold;
    }
  }
`;